module.exports = __webpack_public_path__ + "img/NL358.06588c0b.png";